import Head from 'next/head';
import Image from 'next/image';
import Link from 'next/link';
import { getAllDocs } from '../../utils/static-content';

export default function Events({
  updates
}: {
  updates: { frontMatter: { slug: string; thumbnail: string; title: string; date: string } }[];
}) {
  return (
    <>
      <Head>
        <title>Latest Updates | York Round Table | #DoMore</title>
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <div className="mx-auto w-full max-w-screen-xl">
        <section className="mx-auto w-full max-w-screen-lg mb-16">
          <h1 className="text-4xl text-rt-orange text-center mb-10">Latest updates</h1>
        </section>

        <section className="mx-auto w-full max-w-screen-lg mb-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10">
            {updates.map((article) => (
              <article
                key={article.frontMatter.slug}
                className="flex flex-col rounded-xl overflow-hidden w-full transition transform hover:scale-105">
                <Link href={`/latest-updates/${article.frontMatter.slug}`}>
                  <a className="flex flex-col">
                    {article.frontMatter.thumbnail ? (
                      <Image
                        alt=""
                        src={
                          require(`../../public/updates/${article.frontMatter.thumbnail}`).default
                        }
                        placeholder="blur"
                      />
                    ) : null}
                    <div className="p-5 bg-black bg-opacity-20">
                      <h3 className="text-xl text-rt-orange">{article.frontMatter.title}</h3>
                      <p className="text-white">
                        {new Date(article.frontMatter.date).toLocaleDateString('en-GB', {
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric'
                        })}
                      </p>
                    </div>
                  </a>
                </Link>
              </article>
            ))}
          </div>
        </section>
      </div>
    </>
  );
}

export async function getStaticProps() {
  const updates = await getAllDocs('_news');

  return {
    props: {
      updates: updates.sort((a, b) => {
        // @ts-ignore
        return new Date(b.frontMatter.date) - new Date(a.frontMatter.date);
      })
    }
  };
}
